import { AcceptanceCriteriaBiopsy } from '@/api/apis/cases';

export const organAcceptanceCriteriaBiopsyNames: Record<AcceptanceCriteriaBiopsy, string> = {
  [AcceptanceCriteriaBiopsy.Yes]: 'Yes',
  [AcceptanceCriteriaBiopsy.BasedOnVisual]: 'Based on visual',
};
